<script>
    import {USER_COOKIE} from "./lib/constants";
    import Route, {router} from "./lib/Router/Router.svelte";
    import {cookie} from "./lib/cookie";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import Login from "./components/pages/Login.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Users from "./users/Users.svelte";
    import MemberGifts from "./gifts/MemberGifts.svelte";
    import Barcodes from "./barcodes/Barcodes.svelte";

    let userInitialized = false;
    let appInitialized = false;

    const initUser = async () => {
        // user.initialize();
        let coo = cookie.get(USER_COOKIE) || null;
        if (coo) {
            $user.token = coo;
        }

        userInitialized = true;
    }

    const logoutUser = () => {
        user.clearToken();
        appInitialized = false;
        router.go('/app')();
    }

    const appInitialize = () => {
        const onSuccess = result => {
            $user.id = result.user.id;
            $user.name = result.user.name;
            $user.email = result.user.email;

            // $app.languages = result.languages;
            // $app.defaultLanguage = result.default_language;
            // $app.vehicle_types = result.vehicle_types;
            // $app.settings = result.settings;

            appInitialized = true;
        }

        const onFailure = err => {
        };

        if (!$user.token) {
            return;
        }

        R.handle(R.app.initialize, [], onSuccess, onFailure);
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    initUser();

    $: {
        if ($user.token && !appInitialized) {
            appInitialize();
        }

        // if (appInitialized) {
        //     if (router.url === "/" || router.url === "/app") {
        //         router.go("/app/calendar")();
        //     }
        // }
    }
</script>

{#if !$user.token}
    <Login/>
{:else if appInitialized}
    <PageLoader/>
    <PopupLoader/>
    <AppHeader on:logout={ logoutUser }/>
    <AppMenu/>
    <main>
        <div class="app-main-content">
            <div class="container-fluid">
                <Route match="/">
                    <Route match="users">
                        <Users/>
                    </Route>
                    <Route match="member-gifts">
                        <MemberGifts/>
                    </Route>
                    <Route match="barcodes">
                        <Barcodes/>
                    </Route>
                </Route>
            </div>
        </div>
    </main>
{/if}

<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main {
            padding-left: 50px;
        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main {
            padding-left: var(--aside-width);
        }

        main .app-main-content {
            padding: 30px 10px 20px 10px;
        }
    }
</style>